/**
 * Sélecteur de tags multi-select avec option de création.
 */

import React, { useState } from "react";
import "./TagSelector.css";

/**
 * Affiche un sélecteur de tags avec ajout possible.
 * @param {Object} props
 * @param {Array} props.allTags - Tous les tags disponibles.
 * @param {Array} props.selectedIds - IDs des tags sélectionnés.
 * @param {Function} props.onChange - Callback (nouveaux selectedIds).
 * @param {Function} [props.onCreateTag] - Callback pour créer un nouveau tag.
 */
export default function TagSelector({
  allTags,
  selectedIds,
  onChange,
  onCreateTag,
}) {
  const [newLabel, setNewLabel] = useState("");

  function toggleTag(tagId) {
    if (selectedIds.includes(tagId)) {
      onChange(selectedIds.filter((id) => id !== tagId));
    } else {
      onChange([...selectedIds, tagId]);
    }
  }

  async function handleCreate() {
    const trimmed = newLabel.trim();
    if (!trimmed || !onCreateTag) return;
    await onCreateTag(trimmed);
    setNewLabel("");
  }

  return (
    <div className="tag-selector">
      <div className="tag-chips">
        {allTags.map((tag) => (
          <button
            key={tag.id}
            type="button"
            className={`tag-chip ${selectedIds.includes(tag.id) ? "selected" : ""}`}
            onClick={() => toggleTag(tag.id)}
          >
            {tag.label}
          </button>
        ))}
      </div>
      {onCreateTag && (
        <div className="tag-create">
          <input
            type="text"
            value={newLabel}
            onChange={(e) => setNewLabel(e.target.value)}
            placeholder="Nouveau tag..."
            maxLength={100}
          />
          <button type="button" onClick={handleCreate} className="btn btn-small">
            Ajouter
          </button>
        </div>
      )}
    </div>
  );
}
